import { render, staticRenderFns } from "./AdminSaveResponse.vue?vue&type=template&id=51f8dd8d"
import script from "./AdminSaveResponse.vue?vue&type=script&lang=js"
export * from "./AdminSaveResponse.vue?vue&type=script&lang=js"
import style0 from "./AdminSaveResponse.vue?vue&type=style&index=0&id=51f8dd8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports